export default {
    images: []
};
